var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.294 15.451a5.157 5.157 0 1 1 0-10.315 5.157 5.157 0 0 1 0 10.315m10.836 3.41L16.96 14.69c-.022-.022-.048-.038-.071-.058a7.894 7.894 0 1 0-2.256 2.256c.02.023.035.049.058.07l4.171 4.172a1.604 1.604 0 0 0 2.27-2.269",
  clipRule: "evenodd"
})));
export default SvgSearch;